import React from "react";
import './CourseRating.scss'

const CourseRating = (props) => {
    return(
        <div className="courses-ratings">
            <div className="empty-stars"></div>
            <div className="full-stars" style={{width: `${props.ratingWidth}%`}}></div>
        </div>
    )
}
export default CourseRating;